import React from "react";
import "./ui.scss";

export const Badge: React.FC<{ kind?: "success" | "info" | "highlight"; children: React.ReactNode }>
= ({ kind = "info", children }) => <span className={`badge badge--${kind}`}>{children}</span>;

export default Badge;


